import React, { useEffect, useState } from 'react'
import { useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import CaretDown from '../icons/CaretDown'
import CaretUp from '../icons/CaretUp'
import isIOS from '../../utils/isIOS'

const Container = styled.div`
  position: relative;
  display: inline;
  padding: 15px 0;

  &:hover {
    cursor: pointer;
  }
`
const Select = styled.select`
  text-align-last: right;
  padding-right: 10px;
  appearance: none;
  text-indent: 1px;
  text-overflow: '';
  border: none;
  font-weight: 600;
  cursor: pointer;
  color: #414141;

  &:focus {
    outline: none;
  }
`
const Option = styled.option`
  appearance: none;
  color: #414141;
  display: block;
  width: 100%;
  padding: 0.5rem 1.5rem;
  white-space: nowrap;

  &:focus {
    outline: none;
  }
`

export default function Dropdown({ options }) {
  const [open, setOpen] = useState(false)
  const locale = useStoreState(state => state.locale.locale)

  useEffect(() => {
    const isIOSDevice = isIOS()
    const element = document.querySelector('.dropdown')
    const handleBlurDropdown = () => {
      element.classList.remove('open')
      setOpen(false)
    }

    const handleClickDropdown = () => {
      element.classList.toggle('open')
      setOpen(element.classList.contains('open'))
    }

    element.addEventListener('click', handleClickDropdown)
    element.addEventListener(isIOSDevice ? 'mouseout': 'blur', handleBlurDropdown)

    return () => {
      element.removeEventListener(isIOSDevice ? 'mouseout': 'blur', handleBlurDropdown)
      element.removeEventListener('click', handleClickDropdown)
    }
  }, [])

  const handleOptionChange = ev => {
    const redirectUrl = options.find(
      option => option.code === ev.currentTarget.value,
    )

    window.location.href = `${redirectUrl.url}${window.location.search}`
  }

  const handleDefaultLocale = () => {
    return locale !== 'en' ? locale : ''
  }

  return (
    <Container>
      <Select
        tabindex="-1"
        className="dropdown safari_only_rtl no-zoom"
        defaultValue={handleDefaultLocale()}
        onChange={handleOptionChange}
      >
        {locale === 'en' && (
          <Option value="" disabled selected>
            Select a country
          </Option>
        )}
        {options.map(({ code, language }) => (
          <Option key={code} value={code}>
            {language}
          </Option>
        ))}
      </Select>

      {open ? (
        <CaretUp width="10" height="10" />
      ) : (
        <CaretDown width="10" height="10" />
      )}
    </Container>
  )
}
